import React from 'react';

const InfoPopover = ({ onClose }) => (
    <div className="rc-popover-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-label="Where to find flight details">
        <div className="rc-popover" onClick={e => e.stopPropagation()}>
            <button className="rc-popover-close" onClick={onClose} aria-label="Close">✕</button>
            <p className="rc-popover-title">Where to find your flight number</p>
            <ul>
                <li>On your <strong>boarding pass</strong> - e.g. EZY123 or FR456</li>
                <li>In your <strong>booking confirmation email</strong></li>
                <li>On the <strong>departures board</strong> at the airport</li>
                <li>In your airline's <strong>app or website</strong></li>
            </ul>
        </div>
    </div>
);

export default InfoPopover;
